<template lang="pug">
  .item(:style="style") {{ text }}
</template>
<script>
export default {
  props: ['div', 'height'],
  computed: {
    style () {
      return {
        'background-color': this.div.color,
        'color': this.div.fgcolor,
        'width': this.div.size + '%',
        'height': this.height + 'px',
        'line-height': this.height + 'px'
      }
    },
    text () {
      return this.div.text
    }
  }
}
</script>



// WEBPACK FOOTER //
// SpaceViewItem.vue?6d2cf8c0